import { useFormikContext } from "formik";
import React, { useCallback, useEffect, useState } from "react";

import { Forms, Grid } from "components";
import { signup } from "services";

import { useDebounce } from "hooks/debounce";
import { BrokerValues } from ".";
import { useSignup } from "../../store";

const Statuses = [
  "fetching-company-details",
  "fetched-company-details",
  "",
] as const;

export type BrokerCompanyStatuses = (typeof Statuses)[number];

export const Company = () => {
  const { getValues } = useSignup();
  const { errors, setFieldValue } = useFormikContext<BrokerValues>();

  const [status, setStatus] = useState<BrokerCompanyStatuses>("");

  const [_document, setDocument] = useState("");
  const document = useDebounce(_document);

  const handleCompanyDetails = useCallback(async () => {
    try {
      setStatus("fetching-company-details");
      const partnerType = document.length > 14 ? "legal_entity" : "individual";

      const { name } = await {
        individual: () => signup.findPersonByDocument(document),
        legal_entity: () => signup.findCompanyByDocument(document),
      }[partnerType]();

      setFieldValue("name", name);
    } finally {
      setStatus("fetched-company-details");
    }
  }, [document]); // eslint-disable-line

  useEffect(() => {
    setStatus("");
    if (document && !errors?.document) handleCompanyDetails();
  }, [document, handleCompanyDetails]); // eslint-disable-line

  useEffect(() => {
    if (getValues("broker")) {
      setStatus("fetched-company-details");
    }
  }, []); // eslint-disable-line

  return (
    <div>
      <Grid columns={["auto", "repeat(2, 1fr)"]} gap={[".5rem", "1rem"]}>
        <Forms.InputGroup
          name="document"
          label="CPF/CNPJ"
          placeholder="Digite o CPF/CNPJ"
          mask="document"
          loading={status === "fetching-company-details"}
          onKeyUp={(event) => {
            setDocument(event.target.value);
          }}
        />
      </Grid>

      {status === "fetched-company-details" && (
        <Grid
          gap={[".5rem", "1rem"]}
          space={[".5rem 0 0", "1rem 0 0"]}
          columns={["auto", "repeat(2, 1fr)"]}
        >
          <Forms.InputGroup
            name="name"
            label="Razão social"
            placeholder="Digite a razão social"
          />

          <Forms.InputGroup
            name="susep"
            label="Susep Porto"
            placeholder="Digite a Susep Porto"
          />

          <Forms.InputGroup
            name="email"
            label="E-mail operacional"
            placeholder="Digite o e-mail operacional"
            tip="Utilize um e-mail operacional da corretora para deixá-lo informado sobre o processo de credenciamento."
          />
        </Grid>
      )}
    </div>
  );
};
